import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
  ${flexCenter}
  padding: 24px;

  & > *:first-child {
    margin-right: 10px;
  }
`;
